<template>
  <div style="z-index: -1" class="absolute top-24">
    <img src="../../../assets/images/circle-md.png" alt="circle-md" />
  </div>
</template>

